// form
import { useFormContext, Controller } from 'react-hook-form';
import { MuiColorInput } from 'mui-color-input';
// ----------------------------------------------------------------------

type Props = {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
};

export default function RHFColorpicker({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiColorInput
          {...field}
          format="hex"
          fullWidth
          value={field.value}
          helperText={error ? error?.message : helperText}
          error={!!error}
          {...other}
        />
      )}
    />
  );
}
